var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShoujianxiang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.246 8.917v-.5a.5.5 0 00-.49.4l.49.1zm-4.492 0l.49-.1a.5.5 0 00-.49-.4v.5zM3 3h10V2H3v1zm10 0v10h1V3h-1zm0 10H3v1h10v-1zM3 13V3H2v10h1zm6.756-4.183A1.792 1.792 0 018 10.25v1c1.351 0 2.477-.96 2.736-2.234l-.98-.199zM8 10.25c-.866 0-1.59-.615-1.756-1.433l-.98.2A2.792 2.792 0 008 11.25v-1zm2.246-.833H13.5v-1h-3.254v1zm-4.492-1H2.5v1h3.254v-1zM3 13H2a1 1 0 001 1v-1zm10 0v1a1 1 0 001-1h-1zm0-10h1a1 1 0 00-1-1v1zM3 2a1 1 0 00-1 1h1V2z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shoujianxiang.0432a3dd.svg";
export { SvgTongyongShoujianxiang as ReactComponent };